import React from 'react';
import { Chip } from '@mui/joy';
import type { SeverityLevel } from '../../types/stormtracker';
import { SEVERITY_COLORS, SEVERITY_LABELS } from '../../types/stormtracker';

interface SeverityBadgeProps {
  severity: SeverityLevel;
  size?: 'sm' | 'md' | 'lg';
}

export const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity, size = 'sm' }) => {
  const color = SEVERITY_COLORS[severity];
  const label = SEVERITY_LABELS[severity];

  return (
    <Chip
      size={size}
      color={color}
      variant={severity === 'extreme' ? 'solid' : 'soft'}
      sx={{
        fontWeight: severity === 'severe' || severity === 'extreme' ? 'bold' : 'normal',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
      }}
    >
      {label}
    </Chip>
  );
};

export default SeverityBadge;
